export function toQueryString(obj) {
    const result = {}

    const buildQuery = (prefix, value) => {
        if (Array.isArray(value)) {
            value.forEach((val, index) => {
                buildQuery(`${prefix}[${index}]`, val)
            })
        } else if (typeof value === 'object' && value !== null) {
            for (const key in value) {
                buildQuery(`${prefix}[${key}]`, value[key])
            }
        } else {
            result[prefix] = value
        }
    }

    for (const key in obj) {
        buildQuery(key, obj[key])
    }

    return result
}
